export default ({
    showModal: (componentId) => ({ type: "SHOW_MODAL", componentId }),
    showNotificationModal: (componentId) => ({ type: "SHOW_NOTIFICATION_MODAL", componentId }),
    hideModal: () => ({ type: "HIDE_MODAL" }),
    hideNotificationModal: () => ({ type: "HIDE_NOTIFICATION_MODAL" })
})